import firebase from 'firebase/app';
import 'firebase/firestore';

firebase.initializeApp({
    apiKey: 'AIzaSyA6GT504SjsJjRE0shTCZn9e7CQQ_ia3Ak',
    projectId: 'sjukmat',
});

var db = firebase.firestore();
const settings = {timestampsInSnapshots: true};
db.settings(settings);

export default db;


// WEBPACK FOOTER //
// ./src/firebase.js